module.exports = __webpack_public_path__ + "media/images/emblems/Provence-b8bbc1fdd5778e174a1f9b02d4a37447.png";